import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { checkChance, getOff, setOff } from '../service/cTest'
import { useNavigate, Link } from "react-router-dom";
import { errorMessage, successMessage } from '../utils/toastMessage';
import { useSelector, useDispatch } from 'react-redux'



const ChanceRound = () => {
    const [getOfff,setOfff]=useState([])
    const navigate = useNavigate();
    const user = useSelector((state) => state.user)


    const handleCheckChance=async()=>{
        try {
            const { status, data } = await checkChance(user.value.username);
            if (status === 200) {
                if(data.number==0){
                    errorMessage("شانسی برای گرداندن گردونه ندارید")
                    navigate("/dashboard")
                }
            }
        } catch (ex) {
        }
    }

    const handleGetOff=async()=>{
        try {
            const { status, data } = await getOff();
            if (status === 200) {
                setOfff(data.off)
            }
        } catch (ex) {
        }
    }



    useEffect(() => {
        handleGetOff()
        handleCheckChance()
        document.querySelector(".header").style.display = "none"
        document.querySelector(".footer").style.display = "none"
        return (
            () => {
                document.querySelector(".header").style.display = "flex"
                document.querySelector(".footer").style.display = "block"
            }
        )
    }, [])


    // useEffect(()=>{

    // })
    const rotateFunction = () => {
        var min = 1024;
        var max = 9999;
        var deg = Math.floor(Math.random() * (max - min));
        var remainDeg=(deg-22.5)%360
        var offIndex=null
        if(45<=remainDeg && remainDeg<=90){
            offIndex=0
        }
        else if(135<=remainDeg && remainDeg<=180){
            offIndex=2
        }
        else if(225<remainDeg && remainDeg<270){
            offIndex=1
        }
        else if(315<remainDeg && remainDeg<360){
            offIndex=3
        }


        if(offIndex!=null){
            const { status, data } =  setOff(user.value.username,offIndex);
        }


        document.getElementById('box').style.transform = "rotate(" + deg + "deg)";
        document.getElementById("btn").style.display="none"


        setTimeout(()=>{
            if(offIndex!=null){
                successMessage("خوش شانس بودی !!")
            }
            else{
                errorMessage("خوش شانس نبودی !!")
            }
            navigate("/dashboard")
        },7000)

        
    }
    return (
        <div style={{ textAlign: "center" }}>
            <i className='fa fa-arrow-down' style={{ marginTop: "100px" }}></i>
            <div id="mainbox" className="mainbox">
                <div id="box" className="box">
                    <div className="box1">
                        {getOfff.map((o,i)=>(
                            <span key={o.id} className={`span${i+1}`}><b>{o.offPercent} %</b></span>
                        ))}
                        {/* {console.log(getOfff)}
                        <span className="span1"><b>1</b></span>
                        <span className="span2"><b>2</b></span>
                        <span className="span3"><b>3</b></span>
                        <span className="span4"><b>4</b></span> */}
                    </div>
                    <div className="box2">
                        <span className="span1"><b>پوچ</b></span>
                        <span className="span2"><b>پوچ</b></span>
                        <span className="span3"><b>پوچ</b></span>
                        <span className="span4"><b>پوچ</b></span>
                    </div>
                </div>

            </div>
            <button id='btn' onClick={rotateFunction}>چرخاندن</button>
        </div>
    )
}



export default ChanceRound